import { APP_STORE_URL, PLAY_STORE_URL, DEFAULT_APP_LINK } from '@src/utils/constants';

export const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  }

  if (/android/.test(userAgent)) {
    return 'android';
  }
};

export const getStoreUrl = () => {
  const deviceType = getDeviceType();

  if (deviceType === 'ios') {
    return APP_STORE_URL;
  } else if (deviceType === 'android') {
    return PLAY_STORE_URL;
  }
};

export const handleDeepLink = (appLink: string) => {
  window.location.href = appLink || DEFAULT_APP_LINK;
};

export const padBase64 = (str: string): string => {
  const padding = str.length % 4;

  if (padding) {
    return str + '='.repeat(4 - padding);
  }
  return str;
};
